// const { plus,test } = require("./main.sample");
// import $ from 'jquery'

// import { Swiper } from 'swiper/bundle';
import { scrollAction } from './fjk.scrollaction.js';
import { copyrights } from './fjk.copyrights.js';
import * as project from "./fjk.projects.js"; 
import {
  topSectionHeaderPosition,
  topSectionProjectCategorySwitch,
  justifyHistoryLeadtext,
  mainVidualSlider,
} from "./fjk.top.js";
import {
  recruitMemberSlider
} from './fjk.recruit';
import {mainNavSubmenu} from "./fjk.nav";

import { checkMobile, setMobileClass, mobileNavToggle } from "./fjk.mobile";
import {clickResetButton} from "./fjk.form";
import { historyFunctions } from "./fjk.history";
import { renderTopicsList } from './fjk.topics.js';

const url_pattern = {
  recruit_entry_form: "/recruit/entry",
  history: "/history",
  projects: "/projects",
};

// All pages
copyrights();
scrollAction();
checkMobile();
setMobileClass();
mobileNavToggle();
mainNavSubmenu();

// history
if (location.pathname.indexOf(url_pattern.history) === 0) {
  historyFunctions();
}

// entryform
if(location.pathname.indexOf(url_pattern.recruit_entry_form) === 0){
  clickResetButton();
}
// projects
if(location.pathname.indexOf(url_pattern.projects) == 0){
  project.projectsPageFunctions();
}

// top
mainVidualSlider();

// topics
renderTopicsList();

// import $ from 'jquery/src/jquery'

// topSectionHeaderPosition();
topSectionProjectCategorySwitch();

justifyHistoryLeadtext();

// recruit
recruitMemberSlider();

// console.log("main.app.js")